import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useIsPWAInstalled } from "../../hooks/useIsPWAInstalled";

import SandwichNavigation from "../SandwichNavigation/SandwichNavigation";
import InfoButton from "../InfoButton";
import DownloadButton from "../DownloadButton";

import { ReactComponent as BurgerIcon } from "../../static/images/burger_icon.svg";
import { ReactComponent as SkedyLogo } from "../../static/images/logo.svg";

import "./style.css";

const Header = ({ sandwichToggle, active }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isPWA = useIsPWAInstalled();

  if (
    pathname === "/" ||
    pathname === "/role-selector" ||
    pathname === "/signUp" ||
    pathname === "/signIn" ||
    pathname === "/usedInv" ||
    localStorage.ps10005000 === undefined
  ) {
    return;
  }

  return (
    <>
      <SandwichNavigation active={active} sandwichToggle={sandwichToggle} />
      <header className={`header`}>
        <div className="header-container">
          <div
            className="sandwich"
            onClick={() => {
              sandwichToggle("");
            }}
          >
            <BurgerIcon />
          </div>
          <div
            className="site-logo"
            onClick={() => {
              navigate("/sessions");
            }}
          >
            <SkedyLogo />
          </div>
          <div className="buttons-wrapper">
            {!isPWA && <DownloadButton />}
            {/* <InfoButton /> */}
          </div>
        </div>
      </header>
    </>
  );
};

function areEqual(preValue, postValue) {
  if (preValue.sandwichToggle !== postValue.sandwichToggle) {
    return false;
  } else if (preValue.active !== postValue.active) {
    return false;
  } else {
    return true;
  }
}

export default React.memo(Header, areEqual);
